import angular from 'angular';
import moment from 'moment';
import GLOBAL from 'Helpers/global';

(function() {
    'use strict';

    angular.module('app').component('applicationDetails3', {
        template: require('./application-details.html'),
        controller: Ctrl,
        controllerAs: 'vm'
    });

    Ctrl.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$location',
        '$rootScope',
        'ModalService',
        'QueryService',
        'SessionService',
        '$timeout',
        'logger',
        'Upload',
        'UploadService'
    ];

    function Ctrl(
        $scope,
        $state,
        $stateParams,
        $location,
        $rootScope,
        ModalService,
        QueryService,
        SessionService,
        $timeout,
        logger,
        Upload,
        UploadService
    ) {
        var vm = this;
        vm.user = SessionService.getUser();

        vm.img_guide1 = require('Images/guide1.png');
        vm.img_guide2 = require('Images/guide2.png');
        vm.img_guide3 = require('Images/guide3.png');
        vm.logo = require('Images/logofull3.png');

        vm.guides_imgs = [vm.img_guide1, vm.img_guide2, vm.img_guide3]

        vm.logout = () => {
            SessionService.clearUser();
            location.reload();
        }

        if(!vm.user){
            $state.go('login2');
        }else{
            get_my_booking('interview');
            get_my_booking('mock_demo');
            get_my_booking('fundamental_training');
            get_my_booking('tech_training');

            getData();
        }

        if(vm.user.role == 'admin' || vm.user.role=='ADMIN'){
            vm.logout();
        }
        // console.log(vm.user);
        function get_my_booking(process){
            
            var request = {
                method: 'GET',
                route: { my_hiring_schedule: process }
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const data = response.data.data;
                        console.log(data);
                        vm['booking_' + process] = data;

                        if(JSON.stringify(data) == '{}'){
                            vm['booking_' + process] = null;
                        }
                    },
                    function(error) {
                    }
                )
                .finally(function() {
                    vm.loaded_now = true;
                });
        }

        vm.available_interview_days = [];
        vm.available_mock_demo_days = [];
        vm.available_fundamental_training_days = [];
        vm.available_tech_training_days = [];
        
        // setTimeout(() => {
        //     console.log(vm);
        // }, 1000);
        vm.get_hiring_schedule = (process) => {

            var request = {
                method: 'GET',
                route: { hiring_schedule: process }
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const data = response.data.data;
                        // console.log(data);
                        vm[process + '_data'] = data;
                        vm[process + '_data'].duration = parseInt(vm[process + '_data'].duration);
                        var d = new Date();
                        d.setDate(d.getDate() + vm[process + '_data'].date_range_start - 1);
                        for(var i = 0; i < vm[process + '_data'].date_range_end; i++){
                            d.setDate(d.getDate() + 1);
                            const dname = vm.format(d, 'dd', '+08:00')
                            if(data[dname] && data[dname].length){
                                vm[`available_${process}_days`].push(vm.format(d, 'YYYY-MM-DD', '+08:00'));
                            }
                        }

                        vm[process + '_day_options'] = vm[`available_${process}_days`].map(str => {
                            const m = moment.utc(str + 'T12:00:00Z');
                            return { value: str, dow: m.format('ddd'), num: m.format('D'), mon: m.format('MMM') };
                        });
                    },
                    function(error) {
                    }
                )
                .finally(function() {
                    vm.loaded_now = true;
                });

        }

        vm.interview_picker_options = {
            dateDisabled: check_disabled_interview_date,
            customClass: get_interview_class
        }

        vm.mock_demo_picker_options = {
            dateDisabled: check_disabled_mock_demo_date,
            customClass: get_mock_demo_class
        }

        vm.fundamental_training_picker_options = {
            dateDisabled: check_disabled_fundamental_training_date,
            customClass: get_fundamental_training_class
        }
        
        vm.tech_training_picker_options = {
            dateDisabled: check_disabled_tech_training_date,
            customClass: get_tech_training_class
        }

        function check_disabled_interview_date(data){
            const date = vm.format(data.date, 'YYYY-MM-DD', '+08:00')
            return !vm.available_interview_days.includes(date);
        }

        function check_disabled_mock_demo_date(data){
            const date = vm.format(data.date, 'YYYY-MM-DD', '+08:00')
            return !vm.available_mock_demo_days.includes(date);
        }
        function check_disabled_fundamental_training_date(data){
            const date = vm.format(data.date, 'YYYY-MM-DD', '+08:00')
            return !vm.available_fundamental_training_days.includes(date);
        }
        function check_disabled_tech_training_date(data){
            const date = vm.format(data.date, 'YYYY-MM-DD', '+08:00')
            return !vm.available_tech_training_days.includes(date);
        }

        function get_interview_class(data){
            const date = vm.format(data.date, 'YYYY-MM-DD', '+08:00')
            if(vm.available_interview_days.includes(date)){
                return 'available_schedule';
            }else{
                return '';
            }
        }

        function get_mock_demo_class(data){
            const date = vm.format(data.date, 'YYYY-MM-DD', '+08:00')
            if(vm.available_mock_demo_days.includes(date)){
                return 'available_schedule';
            }else{
                return '';
            }
        }

        function get_fundamental_training_class(data){
            const date = vm.format(data.date, 'YYYY-MM-DD', '+08:00')
            if(vm.available_fundamental_training_days.includes(date)){
                return 'available_schedule';
            }else{
                return '';
            }
        }
        function get_tech_training_class(data){
            const date = vm.format(data.date, 'YYYY-MM-DD', '+08:00')
            if(vm.available_tech_training_days.includes(date)){
                return 'available_schedule';
            }else{
                return '';
            }
        }

        vm.interview_times = [];
        vm.mock_demo_times = [];
        vm.fundamental_training_times = [];
        vm.tech_training_times = [];
        vm.select_hiring_date = (process) => {
            vm[process + '_times'] = [];

            const date = vm.format(vm[process + '_date'], 'YYYY-MM-DD', '+08:00')
            var request = {
                method: 'GET',
                route: { hiring_schedule: process, bookings: date }
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const data = response.data.data.items;
                        // console.log(data);
                        const process_date = vm[process + '_date']
                        const day = vm.format(process_date, 'dd', '+08:00');
                        const duration = vm[process + '_data'].duration;
                        const max_invitees = vm[process + '_data'].max_invitees;

                        // The configured windows are in Philippine time (+08:00,
                        // no DST). Build every slot directly in PH time so the
                        // applicant's own timezone can never shift the wall-clock
                        // (which previously let DST-zone applicants book an hour
                        // off, e.g. 5:00 PM for a 6:00 PM window).
                        const date_str = vm.format(process_date, 'YYYY-MM-DD', '+08:00');

                        vm[process + '_data'][day].forEach(sched => {
                            if(!(sched.start && sched.end && sched.start < sched.end)){
                                return;
                            }

                            const win_start = vm.format(sched.start, 'HH:mm', '+08:00');
                            const win_end   = vm.format(sched.end,   'HH:mm', '+08:00');

                            const start = moment.utc(date_str + 'T' + win_start + ':00+08:00');
                            const end   = moment.utc(date_str + 'T' + win_end   + ':00+08:00');

                            while(start.isBefore(end)){
                                const _end = start.clone().add(duration, 'minutes');

                                const t = {
                                    start: start.clone().utcOffset('+08:00').format('hh:mm A'),
                                    end: _end.clone().utcOffset('+08:00').format('hh:mm A'),
                                    kst: start.clone().utcOffset('+09:00').format('hh:mm A'),
                                    _start: start.toISOString(),
                                    _end: _end.toISOString(),
                                };
                                vm[process + '_times'].push(t);

                                if(data.filter(d => d.start == t._start).length >= max_invitees){
                                    t.disabled = true;
                                }

                                start.add(duration, 'minutes');
                            }

                        });
                    },
                    function(error) {
                    }
                )
                .finally(function() {
                    vm.loaded_now = true;
                });
        }

        vm.book_hiring_schedule = (process, schedule) => {
            
            var req = {
                method: 'POST',
                route: { hiring_schedule: '' }, 
                body: {
                    process,
                    start: schedule._start,
                    end: schedule._end,
                }
            };

            if(vm['rescheduling_' + process]){
                req.method = 'PUT';
                req.route = { hiring_schedule: vm['booking_'+process].id }
                req.body.event_id = vm['booking_' + process].event_id
            }
            console.log(req);
            QueryService.query(req)
                .then(function(response) {
                    var data = response.data.data;
                    vm[process + '_schedule_confirm'] = false;
                    if(process == 'mock_demo'){
                        vm.mock_demo_slot = null;
                        vm.mock_demo_date = null;
                        vm.mock_demo_agreed = false;
                        vm.mock_demo_error = '';
                    }
                    get_my_booking(process);

                    if(vm['rescheduling_' + process]){
                        vm['rescheduling_' + process] = false;
                    }
                }, function(error){
                    console.log('asdkjkjkcx', error.data.errors)
                    if(error && error.data && error.data.message && error.data.message.indexOf('ER_DUP_ENTRY') != -1){
                        alert('This schedule has been taken, Please select a different schedule');
                    }
                    if(error && error.data && error.data.errors && error.data.errors[0].code.indexOf('MAX_BOOKINGS') != -1){
                        alert('Schedule is full');
                    }
                });
        }

        function getData(){
            
            var req = {
                method: 'GET',
                route: { teacher: 'me' }, 
            };

            QueryService.query(req)
                .then(function(response) {
                    var data = response.data.data;
                    vm.data = data;

                    if(vm.data.profile_card){
                        vm.profile_cards = vm.data.profile_card.split('###');
                    }else{
                        vm.profile_cards = [];
                    }

                    if (!vm.data.certificates || !isJsonObject(vm.data.certificates)) {
                        vm.data.certificates = {};
                    }else{
                        vm.data.certificates = JSON.parse(vm.data.certificates);
                    }

                    if(vm.data.quiz && isJsonObject(vm.data.quiz)){
                        vm.data.quiz = JSON.parse(vm.data.quiz);
                        
                        vm.correct_answers = 0;
                        vm.data.quiz.forEach(q => {
                            if(q.correct){
                                vm.correct_answers++
                            }
                        });
                    }

                    if(vm.data.application_status == 'NOT-AGREED'){
                        console.log('asdfl;jkbnh')
                        vm.data.application_status = 'NOT-FINALIZED';
                        vm.save();
                    }

                    if(!vm.data.certificates.schedule){
                        vm.data.certificates.schedule = { days: [], hours: [] };
                    }

                    auto_move_page();
                    get_quiz();
                    check_now();
                });
        }

        
        function check_now(){
            var request = {
                method: 'GET',
                params: false,
                hasFile: false,
                route: { settings: 'hiring' }
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const data = response.data.data;
                        if(parseInt(data.setting_data)){
                            vm.can_apply = true;
                        }else{
                            if(vm.data.application_status == 'NOT-FINALIZED'){
                                vm.data.application_status = 'NOT-HIRING';
                                console.log(vm.data.application_status)
                            }
                        }
                    },
                    function(error) {
                    }
                )
                .finally(function() {
                    vm.loaded_now = true;
                });
        }

        vm.days = ['Sundays', 'Mondays', 'Tuesdays', 'Wednesdays', 'Thursdays', 'Fridays', 'Saturdays'];
        vm.hours = [];
        for(let i = 6; i <= 25; i++){
            let h = (''+i).padStart(2, 0);
            if(h == 25){
                h = '01';
            }
            vm.hours.push(h + ':00');
        }

        vm.click_day = d => {
            const days = vm.data.certificates.schedule.days;
            if(days.indexOf(d) != -1){
                days.splice(days.indexOf(d), 1);
            }else{
                days.push(d);
            }
        };
        vm.click_hour = h => {
            const hours = vm.data.certificates.schedule.hours;
            if(hours.indexOf(h) != -1){
                hours.splice(hours.indexOf(h), 1);
            }else{
                hours.push(h);
            }
        };

        vm.is_day_active = d => {
            return vm.data.certificates.schedule.days.indexOf(d) != -1;
        }
        vm.is_hour_active = h => {
            return vm.data.certificates.schedule.hours.indexOf(h) != -1;
        }

        vm.upload_qr = file => {
            
            var request = {
                method: 'POST',
                url: GLOBAL.set_url({ kakao_qr: '' }),
                data: {
                    'Content-Type': file.type,
                    file
                }
            };

            Upload.upload(request).then(
                function(response) {
                    const kakao_id = response.data.data.data;

                    console.log(kakao_id);
                    vm.data.kakao_qr = kakao_id;
                },
                function(err) {
                    vm.data.kakao_qr = null;
                    logger.error('Invalid QR Code. Upload a proper QR Code from kakao');
                }
            );

        }

        vm.finalize = () => {
            
            vm.data.certificates.has_bio = true;
            vm.data.application_status = 'FINALIZED';
            vm.save();
            
            // var req = {
            //     method: 'PUT',
            //     route: { teacher: vm.user.id }, 
            //     body: { application_status: 'FINALIZED' }
            // };
            // setTimeout(()=>{

            //     QueryService.query(req)
            //         .then(function(response) {
            //             getData();
            //         });
            // }, 15000);
        }

        vm.setup_photo_cropper = (file) => {
            console.log(file);
            
            const canvas = document.getElementById('canvas_profile_card');
            canvas.width = 500;
            canvas.height = 500;
            vm.canvas = canvas;

            const ctx = canvas.getContext('2d');
            ctx.fillStyle = 'black';

            const img = document.getElementById('image');

            img.crossOrigin = 'anonymous';
            img.src = URL.createObjectURL(file);
            img.onload = () => {
                vm.scale = Math.min(img.width, img.height);

                vm.canvas_image = img;
                vm.ctx = ctx;
                vm.new_profile_pic = file;
                vm.canvas_x = 0;
                vm.canvas_y = 0;
                vm.canvas_scale = 1;
                vm.canvas_max_x = img.width;
                vm.canvas_max_y = img.height;
                $scope.$apply();
                redraw();
            };
            vm.editing_profile = true;
        };

        vm.redraw = redraw;
        function redraw() {
            if (!vm.ctx) return false;

            const canvas = document.getElementById('canvas_profile_card');
            vm.ctx.fillStyle = '#000';
            vm.ctx.fillRect(0, 0, 1000, 1000);
            vm.ctx.drawImage(
                vm.canvas_image,
                (vm.canvas_x * vm.canvas_max_x) / vm.canvas_scale / vm.scale,
                (vm.canvas_y * vm.canvas_max_y) / vm.canvas_scale / vm.scale,
                vm.canvas_scale * vm.scale,
                vm.canvas_scale * vm.scale,
                0,
                0,
                canvas.width,
                canvas.height
            );
        }
        vm.upload_profile_picture = upload_profile_picture;
        function upload_profile_picture(){

            const canvas = document.getElementById("canvas_profile_card");
            // const file = canvas.toDataURL('image/png');
            canvas.toBlob((file) => {

                file.name = 'test.png'
                UploadService.upload(
                    file,
                    file.type,
                    { path: 'application_profile', type: file.type },
                    location => {
                        console.log(location)
                        vm.profile_cards.push(location);
                        vm.editing_profile = false;
                    }
                );
            });

        }

        vm.upload_audio_intro = upload_audio_intro;
        function upload_audio_intro(file){
            UploadService.upload(
                file,
                file.type,
                { path: 'application_profile', type: file.type },
                location => {
                    vm.data.audio_introduction = location;
                }
            );

        }

        function isJsonObject(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return JSON.parse(str) instanceof Object;
        }
        vm.isJsonObject = isJsonObject;

        vm.save = (dont_refresh) => {
            
            const data = JSON.parse(JSON.stringify(vm.data));
            console.log(data);
            data.profile_card = vm.profile_cards.join('###');
            data.certificates = JSON.stringify(data.certificates);


            var req = {
                method: 'PUT',
                route: { teacher: vm.user.id }, 
                body: data
            };

            QueryService.query(req)
                .then(function(response) {
                    if(!dont_refresh)
                        getData();
                });
        }

        vm.add_work = () => {
            if(!vm.data.certificates.works){
                vm.data.certificates.works = [];
            }  

            const w = vm.data.certificates.works;

            w.push({});

        };

        

        // vm.finalize = () => {
            
        //     var req = {
        //         method: 'PUT',
        //         route: { teacher: vm.user.id }, 
        //         body: { application_status: 'FINALIZED' }
        //     };

        //     QueryService.query(req)
        //         .then(function(response) {
        //             getData();
        //         });
        // }

        vm.proceed = () => {
            vm.data.certificates.has_kakao = true;
            vm.save();
            auto_move_page();
        }

        vm.proceed_to_pquiz = () => {
            vm.data.certificates.has_quiz = true;
            vm.save();
            auto_move_page();
        }


        vm.can_proceed = () => {
            
            if(!vm.data){
                return false;
            }

            return (
                !!vm.data.certificates.kakao_duration &&
                !!vm.data.kakao_id &&
                !!vm.data.kakao_qr
            )

        }
        vm.can_finalize = () => {

            if(!vm.data){
                return false;
            }

            return (
                !!vm.data.name &&
                !!vm.data.audio_introduction &&
                !!vm.data.about_me &&
                vm.profile_cards.length == 3 &&
                !!vm.data.certificates.university &&
                !!vm.data.certificates.gpa &&
                !!vm.data.certificates.works.length &&
                !!vm.data.certificates.fave_movies &&
                !!vm.data.certificates.fave_movies &&
                !!vm.data.certificates.fave_books &&
                !!vm.data.certificates.hobbies
            )
        };

        //------------------------------------------quiz stuff------------------------------------------
        function get_quiz(){
            var request = {
                method: 'GET',
                hasFile: false,
                route: { quiz: 'teacher2' }
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const d = response.data.data.items.filter(q => q.type == 'GRAMMAR');
                        d.forEach(_d => {
                            _d.choices = _d.choices.replace(/\t/g, '');
                            _d.choices = JSON.parse(_d.choices)[0];
                        });
                        
                        d.sort(() => Math.random());

                        vm.quiz_all = JSON.parse(JSON.stringify(d));
                        vm.quiz = d;
                        // vm.quiz.splice(0, 10)
                        // console.log('vm.quiz', vm.quiz)
                        if(vm.data.quiz && vm.data.quiz.length > 0){

                            if(vm.correct_answers >= 8){
                                vm.quiz_passed = true;
                            }else{
                                vm.quiz_failed = true;
                            }
                            vm.quiz_started = false;
                            vm.pquiz_started = false;

                        }
                        vm.pquiz = response.data.data.items.filter(q => q.type != 'GRAMMAR');

                        vm.pquiz.forEach(e=> {
                            e.choices = e.choices.slice(1,e.choices.length -1).split('\n');
                        });

                        vm.pquiz.sort((a, b) => {
                            return (a.type + a.id).localeCompare(b.type + b.id);
                        });
                        if(!vm.data.certificates.pquiz_answers){
                            vm.data.certificates.pquiz_answers = {};
                        }

                    },
                    function(error) {
                    }
                )
                .finally(function() {
                    vm.loaded_now = true;
                });

        }

        vm.answer_pquiz = (q, c) => {
            // ng-click="vm.pquiz_page = vm.pquiz_page + 1; vm.data.certificates.pquiz_answers[c.id] = $index"
            vm.pquiz_page++;
            vm.data.certificates.pquiz_answers[q.id] = q.choices.indexOf(c);

            if(vm.pquiz_t){
                clearTimeout(vm.pquiz_t);
            }
            vm.save(true);

        }

        vm.get_quiz_by_id = id => {
            if(vm.quiz_all)
                return vm.quiz_all.find(q => q.id === id)
        }
        vm.start_quiz = () => {
            vm.quiz_page = 0;
            vm.quiz_started = true;
            vm.start = new Date();
            update_timer();
        }

        vm.start_pquiz = () => {
            console.log(vm.data.certificates)
            console.log(vm.pquiz)
            vm.pquiz_page = 0;

            if(vm.data.certificates.pquiz_answers){
                vm.pquiz.forEach((p, index) => {
                    // const pqa = vm.data.certificates.pquiz_answers[p.id];

                    if(vm.data.certificates.pquiz_answers.hasOwnProperty(p.id)){
                        vm.pquiz_page = index + 1
                    }else{
                        return;
                    }
                })
            }

            vm.pquiz_started = true;
        }

        vm.is_pquiz_complete = () => {
            let complete = true;
            
            vm.pquiz.forEach((p, index) => {
                if(vm.data.certificates.pquiz_answers.hasOwnProperty(p.id)){
                }else{
                    complete = false
                }
            });
            return complete;
        };

        const __mins = 15;
        const __seconds = 60;
        
        vm.get_timer = ()=>{

            function pad(num) {
                return ("0"+num).slice(-2);
            }
            function hhmmss(secs) {
                var minutes = Math.floor(secs / 60);
                secs = secs%60;
                var hours = Math.floor(minutes/60)
                minutes = minutes%60;
                return `${pad(minutes)}:${pad(secs)}`;
            }

            const start = (vm.start.getTime() || 0);
            const end = (vm.end.getTime() || 0);

            return hhmmss(parseInt((__mins*__seconds*1000 + (start - end))/1000));
        };
        function update_timer(apply){
            vm.end = new Date();

            if(vm.quiz_submitted){
                return false;
            }

            if(__mins*__seconds*1000 + (vm.start.getTime() - vm.end.getTime()) < 0 ){
                vm.submit_quiz();
                vm.ran_out_of_time = true;
            }else{
                $timeout(()=>{update_timer(1)}, 1000);
            }
            if(apply){
                vm.end = new Date();
                $scope.$apply();
            }
        }
        
        vm.submit_quiz = ()=>{
            const answers = vm.quiz.map(q => {return { id: q.id, chosen: q.answer }  });

            vm.loading = true;
            var request = {
                method: 'POST',
                body: {
                    answers
                },
                route: { quiz: 'teacher' }, 
                cache: false
            };

            QueryService.query(request)
                .then(
                    function(response) {
                        const data = response.data.data.answers;
                        vm.answers = data;
                        vm.quiz_submitted = 1;

                        const correct_answers = data.filter(d => d.correct).length;
                        vm.correct_answers = correct_answers;
                        getData();
                    },
                    function(error) {}
                )
                .finally(function() { vm.loading = false; }
            );

        };

        vm.submit_pquiz = () => {
            vm.data.certificates.has_pquiz = true;
            vm.save();
        }
        // ------------------------------------------end quiz stuff------------------------------------------

        vm.pages = {
            kakao: [],
            quiz: ['has_kakao'],
            pquiz: ['has_kakao', 'has_quiz'],
            bio: ['has_kakao', 'has_quiz', 'has_pquiz']
        }

        vm.page_completion = {
            kakao: ['has_kakao'],
            quiz: ['has_kakao', 'has_quiz'],
            pquiz: ['has_kakao', 'has_quiz', 'has_pquiz'],
            bio: ['has_kakao', 'has_quiz', 'has_pquiz', 'has_bio'],
        }

        vm.page_names = {
            kakao: 'Kakao Credentials',
            quiz: 'Skills Based Quiz',
            pquiz: 'Work Preferences and\n Strengths Survey',
            bio: 'Profile',
        }
        vm.page_keys = Object.keys(vm.pages);

        function auto_move_page(){
            Object.keys(vm.pages).forEach(p => {
                if(!vm.is_page_disabled(p)){
                    vm.page = p;
                }
            });
        }

        vm.is_page_disabled = (page) => {
            if(!vm.data || !vm.data.certificates){
                return true;
            }
            const requirements = vm.pages[page];

            let are_requirements_met = true;
            requirements.forEach(r => {
                if(!vm.data.certificates[r]){
                    are_requirements_met = false;
                }
            });

            return !are_requirements_met;
            
        }

        vm.is_page_complete = (page) => {
            if(!vm.data){
                return true;
            }
            const requirements = vm.page_completion[page];

            let are_requirements_met = true;
            requirements.forEach(r => {
                if(!vm.data.certificates[r]){
                    are_requirements_met = false;
                }
            });

            return are_requirements_met;

        }

        vm.format = (date, format, tz) =>
            moment(date)
                .utcOffset(tz || '+09:00')
                .format(format);

        // A booking whose start time has already passed can no longer be
        // rescheduled by the applicant.
        vm.schedule_passed = (booking) =>
            !!(booking && booking.start && moment(booking.start).isBefore(moment()));

        vm.mock_demo_slot = null;
        vm.mock_demo_agreed = false;
        vm.mock_demo_error = '';

        vm.pick_mock_demo_day = (str) => {
            vm.mock_demo_date = new Date(str + 'T00:00:00+08:00');
            vm.mock_demo_slot = null;
            vm.mock_demo_error = '';
            vm.select_hiring_date('mock_demo');
        };

        vm.is_mock_demo_day = (str) =>
            !!vm.mock_demo_date && vm.format(vm.mock_demo_date, 'YYYY-MM-DD', '+08:00') == str;

        vm.confirm_mock_demo = () => {
            if(!vm.mock_demo_date){
                vm.mock_demo_error = 'Please choose a date.';
            }else if(!vm.mock_demo_slot){
                vm.mock_demo_error = 'Please choose a time block.';
            }else if(!vm.mock_demo_agreed){
                vm.mock_demo_error = 'Please confirm you understand the rescheduling policy.';
            }else{
                vm.mock_demo_error = '';
                vm.book_hiring_schedule('mock_demo', vm.mock_demo_slot);
            }
        };

        vm.is_within_3h = (booking) => {
            if(!booking || !booking.start){
                return false;
            }
            const mins = moment(booking.start).diff(moment(), 'minutes');
            return mins > 0 && mins < 180;
        };

        vm.go_to_guidelines =() => $state.go('mock-demo-guidelines');

        vm.mock_demo_name = '';

        vm.first_name = () => {
            const typed = (vm.mock_demo_name || '').trim().split(/\s+/)[0];
            return typed || ((vm.data && vm.data.name) || '').trim().split(/\s+/)[0] || 'Teacher';
        };

        vm.hours_until = (booking) => {
            if(!booking || !booking.start){
                return '';
            }
            const mins = moment(booking.start).diff(moment(), 'minutes');
            if(mins <= 0){
                return 'Started';
            }
            const hrs = Math.floor(mins / 60);
            return hrs >= 24 ? Math.floor(hrs / 24) + 'd ' + (hrs % 24) + 'h' : hrs + 'h ' + (mins % 60) + 'm';
        };
    }
})();



// WEBPACK FOOTER //
// ./src/app/components/application-details-3/application-details.component.js